<template>
  <!-- 以資料第一筆有無判斷 -->
  <div>
    <v-tooltip top v-if="option.helpIcon.enabled">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" class="highchart-help"
          >mdi-help-circle-outline</v-icon
        >
      </template>
      <pre>{{ option.helpIcon.annotation }}</pre>
    </v-tooltip>

    <highcharts
      :options="option"
      v-if="option.series[0].data && option.series[0].data.length > 0"
    />
    <div v-else class="d-flex justify-center">
      <span class="chart-title">{{ option.title.text }} </span>
      <span class="no-data"> No data to display</span>
    </div>
  </div>
</template>

<script>
import highcharts from "highcharts";
import treemap from "highcharts/modules/treemap";
import { genComponent } from "vue-highcharts";
import exportingInit from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import noData from "highcharts/modules/no-data-to-display";

highcharts.Chart.prototype.showResetZoom = function() {
  const chart = this;
  if (!chart.resetZoomImg) {
    chart.resetZoomImg = 1;
    chart.renderer
      .image(require("@/assets/images/zoomout.jpg"), 0, 0, 30, 30) //src, x, y, width, height
      .on("click", function() {
        chart.zoomOut();
        this.remove();
        chart.resetZoomImg = null;
      })
      .on("mouseover", function() {
        this.style["cursor"] = "pointer";
      })
      .attr({
        align: "right",
        zIndex: 100,
      })
      .add(chart.zoomGroupButton)
      .align({
        align: "right",
        x: -35,
        y: 5,
      })
      .add();
  }
};
highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    drillUpText: "Back",
    thousandsSep: ",",
  },
});
//自定義symbol按鈕圖案(也可用網路icon)
highcharts.SVGRenderer.prototype.symbols.download = function(x, y, w, h) {
  var path = [
    // Arrow stem
    "M",
    x + w * 0.5,
    y,
    "L",
    x + w * 0.5,
    y + h * 0.7,
    // Arrow head
    "M",
    x + w * 0.3,
    y + h * 0.5,
    "L",
    x + w * 0.5,
    y + h * 0.7,
    "L",
    x + w * 0.7,
    y + h * 0.5,
    // Box
    "M",
    x,
    y + h * 0.9,
    "L",
    x,
    y + h,
    "L",
    x + w,
    y + h,
    "L",
    x + w,
    y + h * 0.9,
  ];
  return path;
};
treemap(highcharts);
exportingInit(highcharts);
exportData(highcharts);
noData(highcharts);
export default {
  props: {
    option: Object,
  },
  components: {
    Highcharts: genComponent("Highcharts", highcharts),
  },
};
</script>

<style lang="css" scoped>
.no-data {
  position: absolute;
  z-index: 4;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  color: #666666;
  fill: #666666;
  font-size: 12px;
  font-weight: bold;
}
.chart-title {
  font-size: 18px;
  margin-top: 5px;
}

.highchart-help {
  position: absolute;
  z-index: 4;
  top: 3.5%;
  left: 55%;
  transform: translate(400%, -40%);
}

.css-test {
  position: relative;
}
/* .highchart-help {
  position: relative;
  z-index: 4;
  top: 66px;
  left: 65%;
  transform: translate(-100%, -40%);
} */
</style>
